import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputFileSectionFn = /* @__PURE__ */ createRecipe('input-file-section', {}, [])

const inputFileSectionVariantMap = {
  "pointerEvents": [
    "none",
    "auto"
  ]
}

const inputFileSectionVariantKeys = Object.keys(inputFileSectionVariantMap)

export const inputFileSection = /* @__PURE__ */ Object.assign(memo(inputFileSectionFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputFileSection',
  __getCompoundVariantCss__: inputFileSectionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputFileSectionVariantKeys,
  variantMap: inputFileSectionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputFileSectionVariantKeys)
  },
  getVariantProps: inputFileSectionFn.getVariantProps,
})